<div class="row page-titles">
  <div class="col-md-5 align-self-center">
      <h3 class="text-themecolor">Test de dominó</h3>
  </div>
  <app-custom-timer *ngIf="startTimer" (time)="timeInSeconds($event)"></app-custom-timer>

</div>
<app-camera *ngIf="testData && testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>
<div class="row">
  <div class="col-12">
      <div class="card">
          <div class="card-body">
              
              <div *ngIf="texts&&isSim" #instructions class="m-b-30"></div>

              <div class="col-12" >
                  <button class="btn btn-rounded waves-effect btn-rounded btn-info mx-2 mx-2" (click)="reload()">Cancelar</button>

                  <button *ngIf="isSim" type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" [disabled]="!simQuestions" data-toggle="modal" data-target="#myModal" > Realizar simulación </button>
                  <button *ngIf="!isSim" type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" [disabled]="!questions" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>
              </div>
                       
              <div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                          <div class="modal-header">
                              <h4 class="modal-title" id="myModalLabel">TEST DOMINÓ</h4>
                          </div>


                          <div *ngIf="actualPage && !isSim" class="modal-body">
                              <h4>Complete el grupo y haga click en siguiente</h4>

                              <div class="row">
                                <div *ngFor="let question of actualGroup; index as i" class="col-md-6 p-2">
                                  <div class="question-container p-2">
                                    <div class="row">
                                      <div class="col-8">
                                        <img [src]="question.imageUrl" alt="">
                                      </div>
                                      <div class="col-4 response-container">
                                        <h6><b>Respuesta</b></h6>
                                        <div class="ml-2">
                                          <select [(ngModel)]="responses[i + (actualPage - 1) * 6][0]">
                                            <option *ngFor="let number of NUMBERS" [value]="number">{{number}}</option>
                                          </select>
                                        </div>

                                        <div class="ml-2">
                                          <select [(ngModel)]="responses[i + (actualPage - 1) * 6][1]" class="no-top-border">
                                            <option *ngFor="let number of NUMBERS" [value]="number">{{number}}</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <button type="button" class="btn waves-effect waves-light btn-lg btn-rounded btn-info btn-sm float-right" (click)="nextPage()" > Continuar </button>
                          </div>


                          <div *ngIf="isSim" class="modal-body">
                            <h4>Aquí hay dos ejemplos (el A y el B) que ya han sido resueltos. Observe como y porque corresponden esas soluciones. </h4>
                            <h4>Los siguientes (C y D) son otros dos ejemplos. Fíjese bien en cada grupo y trate de averiguar que cifras corresponden al domino vacío: </h4>

                            <div class="row">
                              <div *ngFor="let question of simData; index as i" class="col-md-6 p-2">
                                <div class="question-container p-2">
                                  <div class="row">
                                    <div class="col-8">
                                      <img [src]="question.imageUrl" alt="">
                                    </div>
                                    <div class="col-4 response-container">
                                      <h6><b>Respuesta</b></h6>
                                      <div class="ml-2">
                                        <select [disabled]="i == 0 || i ==1" [(ngModel)]="testResponses[i][0]">
                                          <option *ngFor="let number of NUMBERS" [value]="number">{{number}}</option>
                                        </select>
                                      </div>

                                      <div class="ml-2">
                                        <select [disabled]="i == 0 || i ==1" [(ngModel)]="testResponses[i][1]" class="no-top-border">
                                          <option *ngFor="let number of NUMBERS" [value]="number">{{number}}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button type="button" class="btn waves-effect waves-light btn-lg btn-rounded btn-info btn-sm float-right" (click)="endSim()" > Finalizar </button>
                        </div>



                      </div>
                      <!-- /.modal-content -->
                  </div>
                  <!-- /.modal-dialog -->
              </div>

              <div id="formModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                          <div class="modal-header">
                              <h3 class="modal-title" id="myModalLabel">Por favor, complete el siguiente formulario</h3>
                          </div>
                          <div *ngIf="testData.formModel" class="modal-body p-5">
                              <div class="row justify-content center">
                                  <div *ngFor="let field of testData.formModel; index as i" class="col-md-6 mt-2">
                                      <div *ngIf="field.type=='text'||field.type=='number'" class="form-group">
                                          <span><b>{{field.text}}</b></span>
                                          <input autocomplete="off" [(ngModel)]="formModel[i]" [type]="field.type"  class="form-control" [placeholder]="" >
                                      </div>
                                      <div *ngIf="field.type=='radio'" class="demo-radio-button">
                                          <span><b>{{field.text}}</b></span>
                                          <div class="row">
                                              <div class='col-md-6' *ngFor="let opt of field.data; index as j">
                                                  <input id="enum_answer_{{j}}" [value]='opt' type="radio" name="enums_{{i}}" [(ngModel)]="formModel[i]" >
                                                  <label for="enum_answer_{{j}}">
                                                      {{opt}}
                                                  </label>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <button class="btn btn-success waves-effect pull-right" (click)="sendForm()">Continuar</button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>